let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ltGSX"), load("1tgwx"), load("3HU3r")]).then(() => parcelRequire('iHpDm'));